import { Component, h } from 'preact'
import InputGroup from '../../ui-components/InputGroup'
import { FilterSelectorComponent } from './interfaces'
import SearchableFilterSelector from './SearchableFilterSelector'

type State = {
  data: any
}

class PublishedInFilterSelector extends Component<FilterSelectorComponent, State> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      data: this.props.selectedFilterItems
    }
  }

  render ({ items, selectedFilterItems, children, disableApplyButton }: FilterSelectorComponent, { data }: State) {
    let hasChildren = (Array(children).toString() !== '')
    return <div>
      <SearchableFilterSelector placeholder='Search for category or group'>
        {({ value }: { value: string }) => items.map(item => {
          const filteredItems = item.items.filter((child: { name: string }) => child.name.toLowerCase().includes(value.toLowerCase()))
          return <div key={item.id}>
            {filteredItems.length > 0 &&
              <InputGroup
                formGroupClasses={'overview__filters-box-filter'}
                inline
                title={<strong>{item.parentName}</strong>}
                type='checkbox'
                checked={filteredItems.some((item: any) => data.includes(String(item.value)))}
                onChangeCheckbox={(e) => {
                  const value = filteredItems.map((filteredItem: { value: string }) => String(filteredItem.value))
                  const checked = e.target.checked
                  const payload = checked
                    ? [...data, ...value]
                    : data.filter((x: string) => !value.includes(x))

                  this.setState({ data: payload })
                }} />
            }
            {filteredItems.map((child: { name: string, value: string }) =>
              <InputGroup
                formGroupClasses={'overview__filters-box-filter'}
                inline
                value={child.value}
                title={child.name}
                type='checkbox'
                checked={data.some((value: any) => Number(value) === Number(child.value))}
                onChangeCheckbox={(e) => {
                  const value = e.target.value
                  const checked = e.target.checked
                  const payload = checked
                    ? [...data, value]
                    : data.filter((x: string) => x !== value)

                  this.setState({ data: payload })
                }} />
            )}
          </div>
        })
        }
      </SearchableFilterSelector>
      {hasChildren && children[0]({
        data,
        isApplyButtonDisabled: disableApplyButton ?? data.length === 0
      })}
    </div>
  }
}

export default PublishedInFilterSelector
